module.exports = __webpack_public_path__ + "img/rule-title-right.3dfd1292.png";